export default "<app-loading>\r\n</app-loading>\r\n<app-header></app-header>\r\n<app-footer></app-footer>\r\n";